import React, { useEffect, useState, useRef, useMemo } from 'react';
import debounce from 'lodash/debounce';
import Cookies from 'js-cookie';
import { NewsletterSubscriptionDialog as NewsletterSubscriptionDialogComponent } from '@pegasus/platform-journeys';
import { TranslateScope, useTranslate } from '@pegasus/translation';
import { HOMEPAGE_LOGIN, logout } from '../../../lib/logout';
const DEBOUNCE_TIME = 100;
const SHOW_NEWSLETTER_SUBSCRIPTION_DIALOG_SCROLL_Y = 300;
const SHOW_NEWSLETTER_SUBSCRIPTION_DIALOG_TIMEOUT = 5000;
const HIDE_NEWSLETTER_SUBSCRIPTION_DIALOG_COOKIE_NAME = 'hide_nlsd';
export function NewsletterSubscriptionDialog({ subscribeToNewsletter, isDOIUser, showNotification, showSuccessMessage, hasSecondaryAuth = false, email, firstName, csrfToken, delay, closable = true, forceToShow = false, }) {
    const isHideCookiePresent = useMemo(() => Cookies.get(HIDE_NEWSLETTER_SUBSCRIPTION_DIALOG_COOKIE_NAME) === 'true', []);
    const timerRef = useRef(0);
    const [isModalShown, setIsModalShown] = useState(false);
    const [hasModalBeenShown, setHasModalBeenShown] = useState(forceToShow ? false : isHideCookiePresent);
    const isModalShownRef = useRef(isModalShown);
    const hasModalBeenShownRef = useRef(hasModalBeenShown);
    const translate = useTranslate('newsletterDialog');
    const hideModal = () => {
        setIsModalShown(false);
        if (forceToShow) {
            return;
        }
        Cookies.set(HIDE_NEWSLETTER_SUBSCRIPTION_DIALOG_COOKIE_NAME, 'true', { expires: 10000 });
    };
    useEffect(() => {
        const showModal = () => {
            if (isModalShownRef.current || hasModalBeenShownRef.current) {
                return;
            }
            setIsModalShown(true);
            setHasModalBeenShown(true);
            isModalShownRef.current = true;
            hasModalBeenShownRef.current = true;
        };
        if (hasModalBeenShown || isModalShown) {
            return;
        }
        const timeout = setTimeout(() => {
            showModal();
        }, delay || SHOW_NEWSLETTER_SUBSCRIPTION_DIALOG_TIMEOUT);
        const onScroll = debounce(() => {
            if (window.scrollY > SHOW_NEWSLETTER_SUBSCRIPTION_DIALOG_SCROLL_Y &&
                !isModalShown &&
                !hasModalBeenShown) {
                showModal();
            }
        }, DEBOUNCE_TIME);
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
            clearTimeout(timeout);
        };
    }, [isModalShown, hasModalBeenShown, delay]);
    const onLogout = () => {
        logout(csrfToken, HOMEPAGE_LOGIN);
    };
    return (React.createElement(TranslateScope, { path: "newsletterDialog" },
        React.createElement(NewsletterSubscriptionDialogComponent, { hide: hideModal, onSubscribe: async () => {
                await subscribeToNewsletter().catch(() => { });
                hideModal();
                if (isDOIUser) {
                    showNotification();
                }
                else {
                    showSuccessMessage(translate('voucherApplyMessage'));
                }
            }, isShown: isModalShown, hasSecondaryAuth: hasSecondaryAuth, email: email, firstName: firstName, onLogout: onLogout, closable: closable })));
}
//# sourceMappingURL=index.js.map